import { useTranslation } from "react-i18next";
import { Coins, Sparkles } from "lucide-react";
import GlassCard from "./GlassCard";
import GoldButton from "./GoldButton";
import { formatPrice } from "../lib/billing";
import { cn } from "../lib/utils";

export function PackageCard({ pkg, onBuy, busy }) {
  const { t } = useTranslation();
  const priceText = formatPrice(pkg.price_cents, pkg.currency);
  const labelName = t(pkg.label_key);

  return (
    <GlassCard
      className={cn(
        "p-6 relative overflow-hidden transition-transform duration-200 hover:-translate-y-0.5",
        pkg.popular && "border-[#D4AF37]/55 shadow-[0_18px_40px_-20px_rgba(212,175,55,0.45)]",
      )}
      data-testid={`package-card-${pkg.id}`}
    >
      {pkg.popular && (
        <span
          className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-[#F4D77A] to-[#A8862B] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#0a0a0d]"
          data-testid={`package-card-${pkg.id}-popular`}
        >
          <Sparkles className="h-3 w-3" /> {t("pkg.popular")}
        </span>
      )}

      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-white/50">
        <Coins className="h-3.5 w-3.5 text-[#D4AF37]" />
        {labelName}
      </div>

      <div className="mt-3 flex items-baseline gap-2">
        <span className="font-display text-4xl text-white tabular-nums">
          {pkg.nxt}
        </span>
        <span className="text-sm text-[#D4AF37]">NXT</span>
      </div>

      <div className="mt-1 text-sm text-white/55">{priceText}</div>

      <GoldButton
        onClick={onBuy}
        disabled={busy}
        className="mt-5 w-full justify-center"
        data-testid={`package-buy-btn-${pkg.id}`}
      >
        {t("pkg.buy")} · {priceText}
      </GoldButton>
    </GlassCard>
  );
}

export default PackageCard;
